/* PSI homepage — revamp Wave 3 v4 (24 Oct 2026).
   "Find your theme": big search with instant suggestions (thumbnails), typo-tolerant, quick chips,
   plus the ALL THEMES grid filter and "Show all" collapse. If anything fails the page simply shows every theme. */
(function () {
  'use strict';
  try {
    var first = document.querySelector('[id$="__17664731746dc6d575"]');
    var rest = document.querySelector('[id$="__blocks_iiWNHw"]');
    if (!first) return;
    var sections = [first, rest].filter(Boolean);
    var cards = [];
    sections.forEach(function (s) {
      s.querySelectorAll('a[class^="ai-collection-list__card-"]').forEach(function (a) {
        var img = a.querySelector('img');
        var raw = ((img && img.alt) || a.textContent || '').replace(/\s+/g, ' ').trim();
        if (!raw) return;
        a.classList.add('psi-th-card');
        a.setAttribute('data-psi-name', raw.toLowerCase());
        cards.push({ el: a, name: pretty(raw), key: norm(raw), words: raw.toLowerCase().split(/[^a-z0-9]+/).filter(Boolean),
                     href: a.getAttribute('href'), img: img ? String(img.getAttribute('src') || img.currentSrc || '').replace(/width=\d+/, 'width=120') : '' });
      });
    });
    if (cards.length < 12) return;
    first.classList.add('psi-th-first'); if (rest) rest.classList.add('psi-th-rest');
    var total = cards.length;
    var html = document.documentElement;
    var wa = 'https://wa.me/919841131131?text=' + encodeURIComponent('Hi Party Supplies India! I am looking for a party theme that is not on your website.');

    function norm(s) { return String(s).toLowerCase().replace(/theme/g, '').replace(/[^a-z0-9]+/g, ''); }
    function pretty(s) {
      s = s.replace(/\btheme\b/ig, '').replace(/\s+/g, ' ').trim();
      return s.toLowerCase().replace(/(^|[\s-])([a-z])/g, function (m, p, c) { return p + c.toUpperCase(); });
    }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    var SYN = { dino: 'dinosaur', dinosar: 'dinosaur', dinasour: 'dinosaur', elsa: 'frozen', anna: 'frozen', olaf: 'frozen', spider: 'spiderman', spidey: 'spiderman',
      mcqueen: 'car', cars: 'car', lightning: 'car', shark: 'shark', babyshark: 'shark', bheem: 'bheem', krishna: 'krishna', kanna: 'krishna', ganesha: 'ganesh',
      mickey: 'mickey', minnie: 'minnie', peppa: 'peppa', pig: 'peppa', paw: 'paw', patrol: 'paw', cocomelon: 'coco', melon: 'coco', bat: 'batman', hulk: 'avengers',
      ironman: 'avengers', marvel: 'avengers', superhero: 'avengers', fairy: 'princess', queen: 'princess', rocket: 'space', astronaut: 'space', planet: 'space',
      lion: 'jungle', safari: 'jungle', animal: 'jungle', wild: 'jungle', sea: 'mermaid', ocean: 'mermaid', underwater: 'mermaid', cow: 'farm', football: 'football',
      soccer: 'football', bat_ball: 'cricket', ipl: 'cricket', unicorns: 'unicorn', rainbow: 'unicorn', plane: 'aeroplane', airplane: 'aeroplane', aeroplanes: 'aeroplane',
      bird: 'bird', star: 'twinkle', twinkle: 'twinkle', baby: 'baby', boss: 'boss', kitty: 'kitty', hellokitty: 'kitty', minion: 'minion', mario: 'mario', lego: 'lego' };
    function lev(a, b, max) {
      if (Math.abs(a.length - b.length) > max) return max + 1;
      var pp = null, p = [], i, j; for (j = 0; j <= b.length; j++) p[j] = j;
      for (i = 1; i <= a.length; i++) { var c = [i], m = i;
        for (j = 1; j <= b.length; j++) {
          c[j] = Math.min(p[j] + 1, c[j - 1] + 1, p[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
          if (pp && i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) c[j] = Math.min(c[j], pp[j - 2] + 1);   // swapped letters count as one typo
          if (c[j] < m) m = c[j]; }
        if (m > max) return max + 1; pp = p; p = c; }
      return p[b.length];
    }
    function score(card, q) {
      if (!q) return 0;
      var k = card.key, s = 0;
      if (k.indexOf(q) === 0) s = 100; else if (card.words.some(function (w) { return w.indexOf(q) === 0; })) s = 80; else if (k.indexOf(q) !== -1) s = 60;
      if (!s && q.length >= 4) {
        var max = q.length >= 7 ? 2 : 1;
        var best = Math.min.apply(null, card.words.map(function (w) { return lev(q, w.slice(0, Math.max(q.length, Math.min(w.length, q.length + 1))), max); }).concat([lev(q, k.slice(0, q.length), max)]));
        if (best <= max) s = 40 - best * 10;
      }
      return s;
    }
    function search(v) {
      var raw = norm(v); if (!raw) return { q: '', hits: [] };
      var qs = [raw]; var syn = SYN[raw] || SYN[raw.replace(/s$/, '')]; if (syn) qs.push(syn);
      if (raw.length > 3 && /s$/.test(raw)) qs.push(raw.slice(0, -1));
      var hits = [];
      cards.forEach(function (c, idx) {
        var s = 0; qs.forEach(function (q) { s = Math.max(s, score(c, q)); });
        if (s > 0) hits.push({ c: c, s: s, i: idx });
      });
      hits.sort(function (a, b) { return b.s - a.s || a.i - b.i; });
      return { q: raw, hits: hits };
    }

    // ---- build the finder under the ALL THEMES heading ----
    var heading = first.querySelector('h2');
    if (heading) heading.textContent = 'Find your theme';
    var box = document.createElement('div'); box.className = 'psi-find'; box.id = 'psi-find';
    var chipNames = ['Jungle', 'Dinosaur', 'Cricket', 'Unicorn', 'Frozen', 'Car', 'Mermaid', 'Butterfly', 'Space', 'Spiderman', 'Princess', 'Farm', 'Football', 'Baby Shark'];
    var chips = chipNames.filter(function (n) { return search(n).hits.length; }).slice(0, 10);
    box.innerHTML =
      '<p class="psi-find__lead">' + total + ' themes for boys, girls &amp; first birthdays — every one personalised with your child’s name.</p>' +
      '<div class="psi-find__box" role="combobox" aria-haspopup="listbox" aria-owns="psi-find-list" aria-expanded="false">' +
        '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" stroke-width="2.4"/><path d="M20 20l-4.2-4.2" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>' +
        '<label class="visually-hidden" for="psi-find-input">Search party themes</label>' +
        '<input id="psi-find-input" class="psi-find__input" type="search" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" enterkeyhint="search" aria-autocomplete="list" aria-controls="psi-find-list" placeholder="Type a theme — Jungle, Frozen, Cricket…">' +
        '<button type="button" class="psi-find__clear" aria-label="Clear search" hidden>×</button>' +
        '<ul id="psi-find-list" class="psi-find__list" role="listbox" hidden></ul>' +
      '</div>' +
      '<div class="psi-find__chips" role="group" aria-label="Popular themes">' + chips.map(function (n) { return '<button type="button" class="psi-find__chip" data-q="' + esc(n) + '">' + esc(n) + '</button>'; }).join('') + '</div>' +
      '<p class="psi-find__count" aria-live="polite" hidden></p>';
    if (heading && heading.parentNode) heading.parentNode.insertBefore(box, heading.nextSibling); else first.insertBefore(box, first.firstChild);
    var input = box.querySelector('input'), list = box.querySelector('.psi-find__list'), clear = box.querySelector('.psi-find__clear'),
        count = box.querySelector('.psi-find__count'), combo = box.querySelector('.psi-find__box');
    var act = -1, lastHits = [];

    // show all / fewer
    var wrap = document.createElement('div'); wrap.className = 'psi-th-more-wrap';
    wrap.innerHTML = '<button type="button" class="psi-th-more" aria-expanded="false">Show all ' + total + ' themes</button>';
    var after = rest || first; after.parentNode.insertBefore(wrap, after.nextSibling);
    var btn = wrap.querySelector('button');
    btn.addEventListener('click', function () {
      var open = !html.classList.contains('psi-th-open');
      html.classList.toggle('psi-th-open', open);
      btn.setAttribute('aria-expanded', String(open));
      btn.firstChild.nodeValue = open ? 'Show fewer themes' : 'Show all ' + total + ' themes';
      if (!open) first.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    function setOpen(o) { list.hidden = !o; combo.setAttribute('aria-expanded', String(o)); }
    var lastV = '';
    function render(v) {
      lastV = v; var r = search(v); lastHits = r.hits; act = -1;
      html.classList.toggle('psi-th-searching', !!r.q);
      clear.hidden = !v;
      var hitSet = {}; r.hits.forEach(function (h) { hitSet[h.i] = 1; });
      cards.forEach(function (c, i) { c.el.classList.toggle('psi-th-miss', !!r.q && !hitSet[i]); });
      if (!r.q) { setOpen(false); count.hidden = true; return; }
      if (!r.hits.length) {
        list.innerHTML = '<li class="psi-find__none">No theme called “' + esc(v.trim()) + '” yet. <a href="' + wa + '" target="_blank" rel="noopener">Ask us on WhatsApp</a> — we design custom themes too.</li>';
        setOpen(true); count.hidden = true; return;
      }
      list.innerHTML = r.hits.slice(0, 6).map(function (h, k) {
        return '<li class="psi-find__opt" role="option" id="psi-opt-' + k + '"><a href="' + esc(h.c.href) + '">' +
          (h.c.img ? '<img src="' + esc(h.c.img) + '" alt="" width="46" height="46">' : '') +
          '<span>' + esc(h.c.name) + ' theme<small>Backdrops, cutouts, toppers &amp; more</small></span><span class="go" aria-hidden="true">›</span></a></li>';
      }).join('');
      setOpen(true);
      count.hidden = false; count.textContent = r.hits.length === 1 ? '1 theme found' : r.hits.length + ' themes found — showing them below';
    }
    function move(d) {
      var opts = list.querySelectorAll('.psi-find__opt'); if (!opts.length) return;
      act = (act + d + opts.length) % opts.length;
      opts.forEach(function (o, k) { o.classList.toggle('is-act', k === act); });
      input.setAttribute('aria-activedescendant', 'psi-opt-' + act);
    }
    var t = null;
    input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(function () { render(input.value); }, 60); });
    input.addEventListener('focus', function () { if (input.value) render(input.value); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
      else if (e.key === 'Escape') { setOpen(false); }
      else if (e.key === 'Enter') {
        e.preventDefault();
        if (input.value !== lastV) { clearTimeout(t); render(input.value); }
        var h = lastHits[act >= 0 ? act : 0]; if (h && h.c.href) window.location.href = h.c.href;
        else input.blur();
      }
    });
    clear.addEventListener('click', function () { input.value = ''; render(''); input.focus(); });
    box.querySelectorAll('.psi-find__chip').forEach(function (b) {
      b.addEventListener('click', function () { input.value = b.getAttribute('data-q'); render(input.value); });
    });
    document.addEventListener('click', function (e) { if (!box.contains(e.target)) setOpen(false); });
    html.classList.add('psi-th-ready');
  } catch (e) { if (window.console) console.warn('[psi-home]', e && e.message); }
})();

/* Short helper lines under a few headings */
(function () {
  try {
    var add = function (sel, txt) {
      var s = document.querySelector(sel); if (!s) return; var h = s.querySelector('h2'); if (!h || h.nextElementSibling && h.nextElementSibling.classList.contains('psi-sub')) return;
      var p = document.createElement('p'); p.className = 'psi-sub'; p.textContent = txt; h.parentNode.insertBefore(p, h.nextSibling);
    };
    add('[id$="__176646701709b55779"]', 'The themes families pick most — tap one to see the full set.');
    add('[id$="__17667425163f1fe7b4"]', 'Already have a theme? Pick what you need — backdrops in round, arch & square shapes, cutouts, toppers and more.');
  } catch (e) {}
})();

/* Shop by product: show 3 rows on phones / 2 rows on laptops, then "Show all". */
(function () {
  'use strict';
  try {
    var sec = document.querySelector('[id$="__17667425163f1fe7b4"]');
    if (!sec) return;
    var items = Array.prototype.slice.call(sec.querySelectorAll('li[class^="ai-collection-list__item-"]'));
    if (items.length < 10) return;
    var open = false;
    var wrap = document.createElement('div'); wrap.className = 'psi-th-more-wrap psi-pc-more-wrap';
    wrap.innerHTML = '<button type="button" class="psi-th-more" aria-expanded="false">Show all ' + items.length + ' products</button>';
    sec.appendChild(wrap);
    var btn = wrap.querySelector('button');
    function layout() {
      items.forEach(function (li) { li.classList.remove('psi-th-miss'); });
      if (open) return;
      var top = items[0].offsetTop, cols = 0;
      for (var i = 0; i < items.length && items[i].offsetTop === top; i++) cols++;
      var rows = window.innerWidth < 750 ? 3 : 2, keep = Math.max(cols, 1) * rows;
      items.forEach(function (li, i) { if (i >= keep) li.classList.add('psi-th-miss'); });
      wrap.hidden = keep >= items.length;
    }
    btn.addEventListener('click', function () {
      open = !open; btn.setAttribute('aria-expanded', String(open));
      btn.firstChild.nodeValue = open ? 'Show fewer' : 'Show all ' + items.length + ' products';
      btn.classList.toggle('is-open', open);
      layout();
      if (!open) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(layout, 150); });
    layout();
  } catch (e) { if (window.console) console.warn('[psi-home]', e && e.message); }
})();
